/**
 * Taste Profile v2 conversion stack — scoped to #tp-v2-conversion-stack (Dragon Slayer, etc.).
 * Parity with behaviour in templates/page.taste-profile-v2.liquid: delivery date, marquee copy + pause,
 * box FAQ accordion, video carousel transform, video thumb preview + inline playback.
 */
(function () {
  var testimonialsByProfile = {
    smooth_sipper: [
      { name: 'Marcus T.', text: "Doc Holliday 10-Year and Penelope side by side. Smooth, deep, now my go-to pour. Made me fall back in love with bourbon." },
      { name: 'Katie', text: "Got it for my fiance's birthday. Even the 'lowest quality' bottle made him say 'it's so smooth!' 10/10 recommend." },
      { name: 'Tyler S.', text: "Wasn't sure at first... but it was a really fun experience. Got the Doc Holliday 10, 1792 Sweet Wheat, and Rough Rider." },
      { name: 'Olivia M.', text: "Pulled a 1792 Sweet Wheat in my first box and couldn't believe it. The quality keeps blowing me away." },
      { name: 'Vanessa C.', text: "First box was legit: Penelope Estate Reserve and a 1792 Sweet Wheat. If this is the baseline, I'm excited for what's next." }
    ],
    oak_and_grain_explorer: [
      { name: 'Robert B.', text: "Two bourbons I'd never heard of, two I'd never tried. A great way to explore the world of bourbon." },
      { name: 'Christopher G.', text: 'The Old Lion by Rough Rider is hard to find with wonderful flavor. Alter Ego by Doc Swinson, soft spice. Impressed.' },
      { name: 'Alex B.', text: "Third mystery box. Each came with a tasting card, each excellent in a different way. Bourbons I'd never heard of." },
      { name: 'Brian F.', text: 'For my very first box, it was awesome. I enjoyed both bottles, rare and unique.' },
      { name: 'Guy S.', text: 'Four bourbons of pretty high quality. Mid to upper end proof wise. Doc Holliday was my favorite of the bunch.' }
    ],
    bold_pioneer: [
      { name: 'Nick D.', text: "Second mystery box, first with Whiskey Library. All high proof and hoping they're all bangers." },
      { name: 'Kyle R.', text: 'Stellum is fantastic. Cherry pie, brown sugar, oak on the nose. At 115 proof this thing will sneak up on you.' },
      { name: 'Sarah L.', text: 'Lives up to the hype. Quality pours, fast shipping, zero filler. Got a Four Roses Cask Strength OBSO.' },
      { name: 'Josh Y.', text: "Got a Doc Holliday 10-Year, a Blanton's Single Barrel, and a Four Roses Single Barrel. The value is wild." },
      { name: 'Elite P.', text: "Doc Holliday Cask 7, Rough Rider Double Cask, Old Joe Double Oak 8 Year, James E. Pepper, and Blanton's. Very impressed." }
    ]
  };

  var titleMap = {
    smooth_sipper: 'What other Smooth Sippers saying',
    oak_and_grain_explorer: 'What other Oak & Grain Explorers say',
    bold_pioneer: 'What other Bold Pioneers say'
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function setDeliveryDate(root) {
    var els = root.querySelectorAll('.tp-start-cta__delivery-date');
    if (!els.length) return;
    var d = new Date();
    d.setDate(d.getDate() + 6);
    var day = d.getDay();
    if (day === 0) d.setDate(d.getDate() + 1);
    if (day === 6) d.setDate(d.getDate() + 2);
    var txt = d.toLocaleDateString('en-US', { weekday: 'long', day: 'numeric', month: 'long' });
    els.forEach(function (el) {
      el.textContent = txt;
    });
  }

  function initMarquee(root) {
    var smoothRoot = document.getElementById('tp-v2-smooth-sippers') || root;
    var track = smoothRoot.querySelector('.tp-smooth-sippers__track');
    if (!track || track.dataset.tpV2Ready) return;
    var marquee = smoothRoot.querySelector('.tp-smooth-sippers__marquee');
    var title = smoothRoot.querySelector('.tp-smooth-sippers__title');
    var profileCtx = root.querySelector('[data-taste-profile]');
    var profile = profileCtx ? profileCtx.getAttribute('data-taste-profile') || 'smooth_sipper' : 'smooth_sipper';
    var fixedMarqueeTitle =
      root && typeof root.getAttribute === 'function' ? (root.getAttribute('data-tp-v2-fixed-marquee-title') || '').trim() : '';

    function applyProfileContent(p) {
      var key = testimonialsByProfile[p] ? p : 'smooth_sipper';
      if (title) title.textContent = fixedMarqueeTitle || titleMap[key] || titleMap.smooth_sipper;
      var active = testimonialsByProfile[key] || testimonialsByProfile.smooth_sipper;
      var cardsHtml = active
        .map(function (item) {
          return (
            '<article class="tp-smooth-sippers__card">' +
            '<div class="tp-smooth-sippers__card-head">' +
            '<span class="tp-smooth-sippers__stars">★★★★★</span>' +
            '<p class="tp-smooth-sippers__name">— ' +
            escapeHtml(item.name) +
            '</p></div><p>' +
            escapeHtml(item.text) +
            '</p></article>'
          );
        })
        .join('');
      track.innerHTML = cardsHtml + cardsHtml;
    }

    applyProfileContent(profile);

    if (profileCtx && !profileCtx.dataset.tpV2MarqueeObserving) {
      profileCtx.dataset.tpV2MarqueeObserving = '1';
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'data-taste-profile') {
            applyProfileContent(profileCtx.getAttribute('data-taste-profile') || '');
          }
        });
      }).observe(profileCtx, { attributes: true, attributeFilter: ['data-taste-profile'] });
    }

    if (!track.dataset.tpV2Ready) {
      if (marquee) {
        var addPause = function () {
          marquee.classList.add('is-paused');
        };
        var removePause = function () {
          marquee.classList.remove('is-paused');
        };
        marquee.addEventListener('pointerdown', addPause);
        marquee.addEventListener('pointerup', removePause);
        marquee.addEventListener('pointercancel', removePause);
        marquee.addEventListener('pointerleave', removePause);
      }
      track.dataset.tpV2Ready = '1';
    }
  }

  function initFaqIn(root) {
    var items = root.querySelectorAll('.tp-box-faq .tp-faq__item');
    items.forEach(function (item) {
      if (item.dataset.tpV2FaqBound) return;
      item.dataset.tpV2FaqBound = '1';
      var btn = item.querySelector('.tp-faq__question');
      var answer = item.querySelector('.tp-faq__answer');
      var icon = btn && btn.querySelector('.tp-faq__icon');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('tp-faq__item--open');
        item.classList.toggle('tp-faq__item--open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          answer.setAttribute('hidden', '');
          if (icon) icon.textContent = '+';
        } else {
          answer.removeAttribute('hidden');
          if (icon) icon.textContent = '−';
        }
      });
    });
  }

  function initVideoCarousel(root) {
    var section = root.querySelector('.tp-video-reels');
    if (!section || section.dataset.tpV2CarouselInit) return;
    section.dataset.tpV2CarouselInit = '1';

    var viewport = section.querySelector('.tp-video-reels-carousel__viewport');
    var track = section.querySelector('.tp-video-reels-carousel__track');
    var prevBtn = section.querySelector('.tp-video-reels-carousel__arrow--prev');
    var nextBtn = section.querySelector('.tp-video-reels-carousel__arrow--next');
    var progressFill = section.querySelector('.tp-video-reels-carousel__progress-fill');
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    var cards = track.querySelectorAll('.tp-video-reels-carousel__card');
    var totalCards = cards.length;
    if (totalCards === 0) return;

    var currentIndex = 0;
    var gap = 8;
    var step = 0;
    var maxIndex = 0;

    function updateStep() {
      if (cards[0]) {
        var computedGap = parseFloat(window.getComputedStyle(track).gap || window.getComputedStyle(track).columnGap || '8');
        gap = isFinite(computedGap) ? computedGap : 8;
        var w = cards[0].getBoundingClientRect().width;
        if (!w || !isFinite(w)) w = cards[0].offsetWidth;
        step = (w || 1) + gap;
        var viewportWidth = viewport.getBoundingClientRect().width || viewport.offsetWidth;
        var visibleCount = Math.max(1, Math.floor((viewportWidth + gap) / Math.max(step, 1)));
        maxIndex = Math.max(0, totalCards - visibleCount);
        if (currentIndex > maxIndex) currentIndex = maxIndex;
      }
    }

    function updateProgress() {
      if (!progressFill) return;
      var totalSteps = maxIndex <= 0 ? 1 : maxIndex + 1;
      var percentage = totalSteps <= 1 ? 100 : ((currentIndex + 1) / totalSteps) * 100;
      if (!isFinite(percentage)) percentage = 100;
      progressFill.style.width = percentage + '%';
    }

    function applyTransform() {
      updateStep();
      var offset = -currentIndex * step;
      track.style.transition = '';
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      updateProgress();
    }

    function goNext() {
      if (currentIndex < maxIndex) currentIndex++;
      else currentIndex = 0;
      applyTransform();
    }

    function goPrev() {
      if (currentIndex > 0) currentIndex--;
      else currentIndex = maxIndex;
      applyTransform();
    }

    function dragBaseOffset() {
      updateStep();
      return -currentIndex * step;
    }

    function setTrackPx(px) {
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
    }

    var swipe = { active: false, startX: 0, dx: 0, pointerId: null, captured: false };

    function swipePointerEnd() {
      if (!swipe.active) return;
      swipe.active = false;
      if (swipe.captured && viewport.releasePointerCapture && swipe.pointerId != null) {
        try {
          viewport.releasePointerCapture(swipe.pointerId);
        } catch (err) {}
      }
      swipe.captured = false;
      swipe.pointerId = null;
      track.style.transition = '';
      updateStep();
      var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
      if (swipe.dx <= -thr) goNext();
      else if (swipe.dx >= thr) goPrev();
      else applyTransform();
      swipe.dx = 0;
    }

    function onSwipePointerDown(e) {
      if (swipe.active) return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      swipe.active = true;
      swipe.startX = e.clientX;
      swipe.dx = 0;
      swipe.captured = false;
      swipe.pointerId = e.pointerId != null ? e.pointerId : null;
      track.style.transition = 'none';
    }

    function onSwipePointerMove(e) {
      if (!swipe.active) return;
      swipe.dx = e.clientX - swipe.startX;
      if (!swipe.captured && Math.abs(swipe.dx) > 5 && viewport.setPointerCapture && swipe.pointerId != null) {
        try {
          viewport.setPointerCapture(swipe.pointerId);
        } catch (err2) {}
        swipe.captured = true;
      }
      setTrackPx(dragBaseOffset() + swipe.dx);
    }

    function onSwipeTouchStart(e) {
      if (swipe.active) return;
      if (!e.touches || !e.touches[0]) return;
      swipe.active = true;
      swipe.pointerId = null;
      swipe.startX = e.touches[0].clientX;
      swipe.dx = 0;
      track.style.transition = 'none';
    }

    function onSwipeTouchMove(e) {
      if (!swipe.active || !e.touches[0]) return;
      swipe.dx = e.touches[0].clientX - swipe.startX;
      setTrackPx(dragBaseOffset() + swipe.dx);
    }

    function onSwipeTouchEnd() {
      if (!swipe.active) return;
      swipe.active = false;
      track.style.transition = '';
      updateStep();
      var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
      if (swipe.dx <= -thr) goNext();
      else if (swipe.dx >= thr) goPrev();
      else applyTransform();
      swipe.dx = 0;
    }

    if (window.PointerEvent) {
      viewport.addEventListener('pointerdown', onSwipePointerDown);
      viewport.addEventListener('pointermove', onSwipePointerMove);
      viewport.addEventListener('pointerup', swipePointerEnd);
      viewport.addEventListener('pointercancel', swipePointerEnd);
    } else {
      viewport.addEventListener('touchstart', onSwipeTouchStart, { passive: true });
      viewport.addEventListener('touchmove', onSwipeTouchMove, { passive: true });
      viewport.addEventListener('touchend', onSwipeTouchEnd);
      viewport.addEventListener('touchcancel', onSwipeTouchEnd);
    }

    prevBtn.addEventListener('click', goPrev);
    nextBtn.addEventListener('click', goNext);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        applyTransform();
      });
      ro.observe(viewport);
    }
    window.addEventListener('resize', applyTransform);

    var pageRoot2 = document.querySelector('.taste-profile-page');
    if (pageRoot2 && typeof MutationObserver !== 'undefined') {
      var mo2 = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class' && !pageRoot2.classList.contains('taste-profile-page--loading')) {
            mo2.disconnect();
            requestAnimationFrame(function () {
              applyTransform();
            });
          }
        });
      });
      mo2.observe(pageRoot2, { attributes: true, attributeFilter: ['class'] });
    }

    applyTransform();
    requestAnimationFrame(function () {
      applyTransform();
    });
  }

  function initVideoPlayback(root) {
    var playUrl = root.getAttribute('data-tp-video-play-icon');
    if (!playUrl) {
      var playImg = root.querySelector('.tp-video-reels-carousel__play-btn img');
      playUrl = playImg ? playImg.getAttribute('src') : '';
    }
    var thumbs = root.querySelectorAll('.tp-video-reels-carousel__thumb[data-tp-video-url]');
    thumbs.forEach(function (thumb) {
      if (thumb.dataset.tpV2VideoBound) return;
      thumb.dataset.tpV2VideoBound = '1';
      var videoUrl = thumb.getAttribute('data-tp-video-url');
      if (!videoUrl) return;

      var preview = document.createElement('video');
      preview.src = videoUrl;
      preview.setAttribute('preload', 'metadata');
      preview.setAttribute('muted', '');
      preview.muted = true;
      preview.setAttribute('playsinline', '');
      preview.setAttribute('webkit-playsinline', '');
      preview.className = 'tp-video-reels-carousel__preview';
      preview.addEventListener('loadedmetadata', function () {
        preview.currentTime = 3;
      });
      thumb.insertBefore(preview, thumb.firstChild);

      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        if (thumb.dataset.playing === 'true') return;

        thumb.innerHTML = '';

        var video = document.createElement('video');
        video.src = videoUrl;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('autoplay', '');
        video.muted = false;
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.display = 'block';

        var bar = document.createElement('div');
        bar.className = 'tp-video-controls';

        var muteBtn = document.createElement('button');
        muteBtn.className = 'tp-vc-btn tp-vc-mute';
        muteBtn.setAttribute('aria-label', 'Mute');
        muteBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>';
        muteBtn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          video.muted = !video.muted;
          muteBtn.innerHTML = video.muted
            ? '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 18l1.98 2L21 18.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>';
        });

        var speedBtn = document.createElement('button');
        speedBtn.className = 'tp-vc-btn tp-vc-speed';
        speedBtn.setAttribute('aria-label', 'Playback speed');
        speedBtn.textContent = '1×';
        var speeds = [1, 1.5, 2, 0.5];
        var speedIdx = 0;
        speedBtn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          speedIdx = (speedIdx + 1) % speeds.length;
          video.playbackRate = speeds[speedIdx];
          speedBtn.textContent = speeds[speedIdx] + '×';
        });

        var fsBtn = document.createElement('button');
        fsBtn.className = 'tp-vc-btn tp-vc-fs';
        fsBtn.setAttribute('aria-label', 'Full screen');
        fsBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>';
        fsBtn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var el = video;
          if (el.requestFullscreen) el.requestFullscreen();
          else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
          else if (el.webkitEnterFullscreen) el.webkitEnterFullscreen();
        });

        bar.appendChild(muteBtn);
        bar.appendChild(speedBtn);
        bar.appendChild(fsBtn);

        var pauseOverlay = document.createElement('div');
        pauseOverlay.className = 'tp-video-pause-overlay';
        if (playUrl) {
          var poImg = document.createElement('img');
          poImg.src = playUrl;
          poImg.width = 38;
          poImg.height = 38;
          poImg.alt = '';
          pauseOverlay.appendChild(poImg);
        }
        pauseOverlay.style.display = 'none';
        pauseOverlay.addEventListener('click', function (ev) {
          ev.stopPropagation();
          video.play();
        });

        video.addEventListener('click', function (ev) {
          ev.stopPropagation();
          if (video.paused) video.play();
          else video.pause();
        });

        video.addEventListener('pause', function () {
          pauseOverlay.style.display = 'flex';
        });

        video.addEventListener('play', function () {
          pauseOverlay.style.display = 'none';
        });

        thumb.appendChild(video);
        thumb.appendChild(pauseOverlay);
        thumb.appendChild(bar);
        thumb.dataset.playing = 'true';
      });
    });
  }

  function boot() {
    var root = document.getElementById('tp-v2-conversion-stack');
    if (!root || root.dataset.tpV2StackBooted) return;
    root.dataset.tpV2StackBooted = '1';

    var playIcon = root.querySelector('.tp-video-reels-carousel__play-btn img');
    if (playIcon && playIcon.src) root.setAttribute('data-tp-video-play-icon', playIcon.src);

    setDeliveryDate(root);
    initMarquee(root);
    initFaqIn(root);
    initVideoCarousel(root);
    initVideoPlayback(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
